import React from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd';
import Paper from '@mui/material/Paper';
import { boxShadow } from '../bulkUpload/functions';

const style = {
  fontSize: 'small',
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  maxWidth: 130
};
export const FileBox = ({ file }) => {
  const { name, type } = file;
  const [{ opacity }, drag] = useDrag(
    () => ({
      type: type,
      item: file,
      collect: monitor => ({
        opacity: monitor.isDragging() ? 0.6 : 1
      })
    }),
    [name]
  );

  return (
    <div ref={drag} style={{ ...style, opacity }}>
      <Paper title={file.fileName} elevation={3} style={{ margin: 10, boxShadow: boxShadow(file.addedToComposeDoc) }}>
        {file?.name}
      </Paper>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={file.fileName}>
        {file.fileName}
      </span>
    </div>
  );
};

FileBox.propTypes = {
  file: PropTypes.object
};
